import { t } from "../../translations";

import "../styles/section-chef.css";

import { useEffect, useState } from "react";
import { DELETE, GET, POST, UPDATE } from "../constants/request-type";
import { service_api } from "../constants/url";
import { MakeRequestAsync } from "../functions/axios";
import { decryptSingleData } from "../functions/cryptojs";

import { CircularProgress, Dialog, DialogContent } from "@mui/material";
import { createLogger } from "../../utils/logger";
import { uploadFile } from "../functions/upload-file";
import TableBlog from "../tables/table-blog";
import { openNotificationWithIcon } from "./notification-bar";
const logger = createLogger("SelectBlog");

const SelectBlog = (props) => {
  const { lang, user } = props;

  const [open, setOpen] = useState(false);

  const [blogList, setBlogList] = useState([]);

  const [blog, setBlog] = useState({
    title: "",
    message: "",
    pic: null,
    chef_id: user?._id
  });

  const [errorText, setErrorText] = useState("");

  const [load, setLoad] = useState(false);

  useEffect(() => {
    initialData();
  }, []);

  // useEffect(() => {}, [live]);

  const initialData = async () => {
    setLoad(true);
    const request_details = {
      type: GET,
      url: service_api,
      route: `blog/get-chef-blog/${user?._id}`,
      data: null,
      token: user?.refresh_token
    };

    try {
      const response = await MakeRequestAsync(request_details);
      const decryptedData = decryptSingleData(response.data.blog);
      setBlogList(decryptedData);
    } catch (err) {
      logger.log("We couldn't fetch data: ", err?.response?.data?.message);
    } finally {
      setLoad(false);
    }
  };

  const deleteBlog = async (_id) => {
    setLoad(true);
    const request_details = {
      type: DELETE,
      url: service_api,
      route: `blog/delete/${_id}`,
      data: {
        deleted: true
      },
      token: user?.refresh_token
    };

    try {
      await MakeRequestAsync(request_details);
      // ✅ Better - Update component state instead of full page reload
      // Remove the deleted blog from local state or refetch data
      setBlogList((prevBlogs) => prevBlogs.filter((blog) => blog._id !== _id));
    } catch (err) {
      logger.log("We couldn't fetch data: ", err?.response?.data?.message);
    } finally {
      setLoad(false);
    }
  };

  const updateBlog = async (_id, status) => {
    setLoad(true);
    const request_details = {
      type: UPDATE,
      url: service_api,
      route: `blog/update-blog/${_id}`,
      data: {
        status: status
      },
      token: user?.refresh_token
    };

    try {
      await MakeRequestAsync(request_details);
      // ✅ Better - Update component state instead of full page reload
      // Update the blog status in local state
      setBlogList((prevBlogs) =>
        prevBlogs.map((blog) => (blog._id === _id ? { ...blog, status } : blog))
      );
    } catch (err) {
      logger.log("We couldn't fetch data: ", err?.response?.data?.message);
    } finally {
      setLoad(false);
    }
  };

  const submitBlogRequest = async () => {
    if (blog.title.length === 0 || blog.message.length === 0) {
      setErrorText(t("validation.you_must_fill_a", lang));
      return openNotificationWithIcon(
        "error",
        t("validation.you_must_fill_a", lang)
      );
    }

    if (blog.pic === null) {
      setErrorText(t("validation.please_select_a", lang));
      return openNotificationWithIcon(
        "error",
        t("validation.please_select_a", lang)
      );
    }

    setLoad(true);

    let pic = await uploadFile(blog.pic);

    if (!pic.data.success) {
      setLoad(false);
      setErrorText(t("blog.upload_error", lang));
      return openNotificationWithIcon("error", t("blog.upload_error", lang));
    }

    const request_details = {
      type: POST,
      url: service_api,
      route: `blog/create-blog`,
      data: {
        ...blog,
        pic: pic.data.url
      },
      token: user?.refresh_token
    };

    try {
      const response = await MakeRequestAsync(request_details);
      // ✅ Better - Update component state instead of full page reload
      // Add the new blog to local state or refetch data
      const newBlog = response.data.blog;
      setBlogList((prevBlogs) => [newBlog, ...prevBlogs]);
      // Reset form
      setBlog({ title: "", message: "", pic: null });
    } catch (err) {
      logger.log("We couldn't fetch data: ", err?.response?.data?.message);
      setErrorText(t("blog.submit_error", lang));
      return openNotificationWithIcon("error", t("blog.submit_error", lang));
    } finally {
      setLoad(false);
    }
  };

  return (
    <div className="section-chef-menu-right-food">
      <div className="section-chef-menu-right-food-inside">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between"
          }}
        >
          <div
            className="section-chef-menu-right-food-inside-filter"
            style={{
              width: "48%",
              height: 250
            }}
          >
            <p
              style={{
                textAlign: "left",
                fontSize: 18,
                fontWeight: 600
              }}
            >
              {t("common.my_blog", lang)}
            </p>
            <div
              style={{
                width: "100%",
                display: "flex"
              }}
            >
              <div
                style={{
                  width: "100%"
                }}
              >
                <p
                  style={{
                    textAlign: "left",
                    fontSize: 15
                  }}
                >
                  {t("blog.total_active_posts", lang)}
                </p>
                {/* {JSON.stringify(orderList)} */}
                <p
                  style={{
                    textAlign: "left",
                    fontSize: 30,
                    fontWeight: "bold",
                    color: "green"
                  }}
                >
                  {
                    blogList.filter((item) => {
                      return item.status === true;
                    }).length
                  }
                </p>
                <p
                  style={{
                    textAlign: "left",
                    fontSize: 15
                  }}
                >
                  {t("blog.total_inactive_posts", lang)}
                </p>
                <p
                  style={{
                    textAlign: "left",
                    fontSize: 30,
                    fontWeight: "bold",
                    color: "blue"
                  }}
                >
                  {
                    blogList.filter((item) => {
                      return item.status === false;
                    }).length
                  }
                </p>
              </div>
              <div
                className="btn-get-started"
                style={{
                  backgroundColor: "#fff",
                  color: "#000",
                  border: "1px solid #cecece",
                  width: "100%"
                }}
                onClick={() => {
                  setOpen(true);
                }}
              >
                {!load && t("buttons.add_blog_post", lang)}
                {load && <CircularProgress size={25} />}
              </div>
            </div>
          </div>
        </div>

        <div
          className="section-chef-menu-right-food-inside-filter"
          style={{
            width: "100%",
            height: "auto",
            marginTop: 30
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end"
            }}
          >
            <div
              className="btn-get-started"
              style={{
                backgroundColor: "#fff",
                color: "green",
                width: 150
              }}
              onClick={() => {
                if (load) {
                  return;
                }
              }}
            >
              {!load && t("common.export_csv_exce", lang)}
              {load && <CircularProgress size={25} />}
            </div>
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center"
            }}
          >
            {!load && (
              <TableBlog
                data={blogList}
                updateBlog={updateBlog}
                deleteBlog={deleteBlog}
              />
            )}
          </div>
        </div>
      </div>

      <Dialog
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        
      >
        <DialogContent>
          <div
            style={{
              minWidth: 300,
              height: "100%"
            }}
          >
            <div>
              <p
                style={{
                  textAlign: "left",
                  display: "flex",
                  alignItems: "center",
                  gap: 15,
                  fontWeight: 600,
                  marginTop: 30,
                  fontSize: 17
                }}
              >
                {t("common.blog", lang)}
              </p>
              <p
                style={{
                  textAlign: "left",
                  fontSize: 15
                }}
              >
                {t("common.register_a_blog", lang)}
              </p>
              {/* {JSON.stringify(address)} */}
              <div className="section-chef-menu-right-address-inside-box">
                {[
                  {
                    placeholder: t("common.title"),
                    name: "title",
                    type: "input",
                    type_input: "text",
                    value: blog?.title,
                    onChange: (e) =>
                      setBlog({
                        ...blog,
                        title: e.target.value
                      })
                  },
                  {
                    placeholder: t("common.content"),
                    name: "message",
                    type: "textarea",
                    type_input: "text",
                    value: blog?.message,
                    onChange: (e) =>
                      setBlog({
                        ...blog,
                        message: e.target.value
                      })
                  },
                  {
                    placeholder: t("common.picture"),
                    name: "pic",
                    type: "file",
                    type_input: "file",
                    value: blog?.pic,
                    onChange: (e) => {
                      setBlog({
                        ...blog,
                        pic: e.target.files[0]
                      });
                    }
                  }
                ]?.map((item) => (
                  <div
                    onClick={() => {}}
                    style={{
                      width: "100%"
                    }}
                  >
                    {item?.type === "input" && (
                      <input
                        style={{
                          height: 40
                        }}
                        className="select-address-box"
                        placeholder={item?.placeholder}
                        // placeholderStyle
                        name={item?.name}
                        value={item?.value}
                        type={item?.type_input}
                        onChange={(e) => {
                          // e.preventDefault();
                          item?.onChange(e);
                        }}
                      />
                    )}

                    {item?.type === "textarea" && (
                      <textarea
                        style={{
                          height: "auto"
                        }}
                        rows={4}
                        className="select-address-box"
                        placeholder={item?.placeholder}
                        // placeholderStyle
                        name={item?.name}
                        value={item?.value}
                        type={item?.type_input}
                        onChange={(e) => {
                          // e.preventDefault();
                          item?.onChange(e);
                        }}
                      />
                    )}

                    {item?.type === "file" && (
                      <input
                        style={{
                          height: "auto"
                        }}
                        rows={4}
                        className="select-address-box"
                        placeholder={item?.placeholder}
                        // placeholderStyle
                        name={item?.name}
                        // value={item?.value}
                        type={item?.type_input}
                        onChange={(e) => {
                          // e.preventDefault();
                          item?.onChange(e);
                        }}
                      />
                    )}
                  </div>
                ))}
              </div>
            </div>

            <div
              className="btn-get-started"
              style={{
                backgroundColor: "#ff114d",
                width: "100%"
              }}
              onClick={() => {
                if (load) {
                  return;
                }

                submitBlogRequest();
              }}
            >
              {!load && t("buttons.save", lang)}
              {load && <CircularProgress size={25} />}
            </div>
          </div>
          <span style={{ color: "red" }}>{errorText}</span>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default SelectBlog;
